import { render, staticRenderFns } from "./RevisionForm.vue?vue&type=template&id=0087ccf9"
import script from "./RevisionForm.vue?vue&type=script&lang=js"
export * from "./RevisionForm.vue?vue&type=script&lang=js"
import style0 from "./RevisionForm.vue?vue&type=style&index=0&id=0087ccf9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports